export default __webpack_public_path__ + "static/step1-51f5c5162cf95800fe5fa275beb8d9c6.svg";